import React, { useState } from "react";

import Avatar from "../../../components/common/Avatar";
import MediaUploader from "../../../components/features/MediaUploader";
import Button from "../../../components/form/Button";
import { useAppSelector } from "../../../redux/hooks";
import {
  useGetUserQuery,
  useUpdateUserMutation,
} from "../../../redux/services/user";
import { RootState } from "../../../redux/store";
import { uploadAvatar } from "../../../utils";

const ProfilePhoto = () => {
  const authToken = useAppSelector((state: RootState) => state.auth.token);
  const [editPhoto, setEditPhoto] = useState(false);

  const { data: user, isLoading: loading } = useGetUserQuery();
  const [
    updateUser,
    {
      isLoading: isLoadingUpadte,
      //   isSuccess: isSuccessUpdate,
      //   isError: isErrorUpdate,
      //   error: errorUpdate,
      //   data: updateResponse,
    },
  ] = useUpdateUserMutation();

  if (loading) return null;

  const handleProfilePhotoUpdate = async (profilePictureUrl: string) => {
    await updateUser({
      profilePictureUrl,
    })
      .unwrap()
      .catch(() => {});
  };

  const handleProfilePictureUpload = async (file: any, _: any) => {
    if (!authToken) return;

    const uploadedFileURL = await uploadAvatar(file, authToken);
    if (uploadedFileURL) {
      handleProfilePhotoUpdate(uploadedFileURL);
    }
  };

  const { firstName, lastName, profilePictureUrl } = user;

  return (
    <>
      <div className="flex items-center gap-4">
        <Avatar
          round
          name={`${firstName} ${lastName}`}
          src={profilePictureUrl}
          size="80px"
        />
        <Button
          variant="transparent-primary"
          onClick={() => setEditPhoto(true)}
        >
          Change
        </Button>
      </div>
      {editPhoto && (
        <MediaUploader
          heading="Upload Photo"
          src={profilePictureUrl ?? ""}
          loading={isLoadingUpadte}
          onClose={() => setEditPhoto(false)}
          onUpload={handleProfilePictureUpload}
          onDelete={() => handleProfilePhotoUpdate("")}
        />
      )}
    </>
  );
};

export default ProfilePhoto;
